import { render } from "./ProjectEditing.vue?vue&type=template&id=24c90385"
import script from "./ProjectEditing.vue?vue&type=script&lang=js"
export * from "./ProjectEditing.vue?vue&type=script&lang=js"
script.render = render

export default script